import React, { useState } from 'react';
import { ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const FaqSection = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: 'How do I apply the NightPhase patch?',
    answer: 'Apply the patch to the inside of your wrist 30 minutes before bedtime. The patch should be placed on clean, dry skin. Each patch is designed to be worn for a single night and should be removed upon waking.'
  }, {
    question: 'Is NightPhase habit-forming?',
    answer: "No. Unlike many sleep aids, NightPhase contains no habit-forming ingredients. Our botanical blend works with your body's natural sleep mechanisms without creating dependency. You can use NightPhase as needed without concerns about withdrawal effects."
  }, {
    question: 'Are there any side effects?',
    answer: 'NightPhase is formulated with natural botanicals that have been safely used for centuries. Most users experience no side effects. A small percentage may experience mild skin sensitivity at the application site. If you have known allergies to any of our ingredients, please consult your healthcare provider before use.'
  }, {
    question: 'How is NightPhase different from melatonin supplements?',
    answer: "Unlike melatonin, which can disrupt your body's natural hormone production and often causes morning grogginess, NightPhase works with your body's existing sleep mechanisms. Our transdermal delivery system provides consistent release throughout the night, avoiding the 'knockout' effect and morning hangover associated with melatonin and other sleep aids."
  }, {
    question: 'How quickly does NightPhase ship?',
    answer: 'All orders are processed within 24 hours and typically ship the same business day when ordered before 2pm ET. We offer expedited shipping options at checkout. Most customers in the continental US receive their order within 2-3 business days.'
  }];
  const toggleFaq = (index: number) => {
    if (openIndex === index) {
      setOpenIndex(null);
    } else {
      setOpenIndex(index);
    }
  };
  return <section className="py-16 md:py-24" data-id="element-142">
      <div className="container mx-auto px-4" data-id="element-143">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-6" data-id="element-144">
          Frequently Asked Questions
        </h2>
        <p className="text-lg md:text-xl text-gray-700 text-center max-w-3xl mx-auto mb-16" data-id="element-145">
          Everything you need to know about NightPhase and how it can transform
          your sleep and performance.
        </p>
        <div className="max-w-3xl mx-auto" data-id="element-146">
          {faqs.map((faq, index) => <div key={index} className="mb-4 border border-gray-200 rounded-lg" data-id="element-147">
              <button className="flex justify-between items-center w-full p-5 text-left bg-white hover:bg-gray-50 transition-colors rounded-lg focus:outline-none" onClick={() => toggleFaq(index)} data-id="element-148">
                <span className="font-semibold text-lg" data-id="element-149">{faq.question}</span>
                {openIndex === index ? <ChevronUpIcon className="w-5 h-5 text-indigo-800" data-id="element-150" /> : <ChevronDownIcon className="w-5 h-5 text-indigo-800" data-id="element-151" />}
              </button>
              {openIndex === index && <div className="p-5 pt-0 text-gray-700" data-id="element-152">
                  <p data-id="element-153">{faq.answer}</p>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
};
export default FaqSection;